/**
 * Renders an email address in a way that's invisible to spam crawlers
 * but fully functional for real users. The email is split and reversed
 * so it never appears as a plain string in the DOM or source.
 */

interface ObfuscatedEmailProps {
  className?: string;
  label?: string;
}

const ObfuscatedEmail = ({ className, label }: ObfuscatedEmailProps) => {
  // Split into parts — never assembled as a plain string in source
  const user = ['t', 'c', 'a', 't', 'n', 'o', 'c'].reverse().join('');
  const domain = ['a', 'c', '.', 'a', 'r', 't', 'x', 'i', 'v'].reverse().join('');
  const address = `${user}@${domain}`;

  const handleClick = () => {
    window.location.href = `mailto:${address}`;
  };

  return (
    <span
      onClick={handleClick}
      className={`cursor-pointer ${className ?? ''}`}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      aria-label="Send us an email"
    >
      {label ?? address}
    </span>
  );
};

export default ObfuscatedEmail;
